"use client";

import React, { useState } from "react";

import publicConfig from "config/public";
import useDomainCountryCode from "hooks/useDomainCountryCode";

import LegalLogo from "components/Icons/legal-logo.svg";

import Select from "../botanic/Select";

const { leaflyDomain, leaflyCaDomain } = publicConfig;

const REDIRECTS_BY_COUNTRY_CODE: Record<string, string> = {
  CA: leaflyCaDomain,
  US: leaflyDomain,
};

export type AgeGateChildFormProps = {
  confirm: () => void;
  rememberUser: boolean;
  setRememberUser: (rememberUser: boolean) => void;
};

type AgeGateFormProps = {
  children: React.ReactNode;
};

const AgeGate: React.FC<AgeGateFormProps> = ({ children }) => {
  const domainCountryCode = useDomainCountryCode();

  const [redirectingDomain, setRedirectingDomain] = useState<string>();

  const shouldRedirect = (selectedCountryCode: string) => {
    if (selectedCountryCode !== domainCountryCode) {
      const redirectUrl = REDIRECTS_BY_COUNTRY_CODE[selectedCountryCode];

      setRedirectingDomain(redirectUrl);
      window.location.assign(redirectUrl);
    }
  };

  return (
    <>
      <div className="mb-sm text-green">
        <LegalLogo width="144" height="64" />
      </div>
      <div className="font-extrabold mb-xl text-md">
        Learn. Shop. Get cannabis.
      </div>

      <div className="pb-sm">
        <Select
          id="age-gate-country"
          data-testid="age-gate-modal-select"
          aria-label="Select your country"
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
            shouldRedirect(e.target.value)
          }
          defaultValue={domainCountryCode}
          label={"Where are you from?"}
        >
          <option value="US">United States</option>
          <option value="CA">Canada</option>
        </Select>
      </div>
      {redirectingDomain && (
        <p className="pt-xs">Redirecting you to {redirectingDomain}</p>
      )}

      {children}
    </>
  );
};

export default AgeGate;
